module.exports = __webpack_public_path__ + "img/Facebook.24e0cbe8.png";